import {React, useState} from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

import { Button, ButtonGroup } from "@chakra-ui/react";
import { useDisclosure } from "@chakra-ui/react";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
} from "@chakra-ui/react";
import { Input } from "@chakra-ui/react";
import {createSubEvent} from "../../../../../services/Api"
import { useToast } from "@chakra-ui/react";

const AddEvent = () => {
    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const initial = {
        name: "",
        description: "",
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
    };
    
    const [event , setEvent] = useState(initial);
    const handleChange = (e) => {
        setEvent({ ...event, [e.target.name]: e.target.value });
        console.log(event);
    }
    const [click , setClick] = useState(true);
    
    const handleSubmit = async () => {
        // console.log(event);
        setClick(false);
        try {
          const data = await createSubEvent(event);
          if(data?.data) {
            console.log(data);
            toast({
              title: "Create Event",
              description: `${data.data.message}`,
              status: "success",
              duration: 9000,
              isClosable: true,
            });
            window.location.reload();  
          } else {
            toast({
              title: "Create Event",
              description: `${data.data.message}`,
              status: "error",
              duration: 9000,
              isClosable: true,
            });
          }
        } catch (error) {
          console.log(error);
          toast({
            title: "Error Processing Request",
            // description: `${data.data.message}`,
            status: "error",
            duration: 9000,
            isClosable: true,
          });
        }
        setClick(true);
    }
    
  return (
    <>
      <Button onClick={onOpen}>Add Event</Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Event</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Name</FormLabel>
              <Input
                type="email"
                name="name"
                onChange={(e) => {
                  handleChange(e)
                }}
              />

              <FormLabel>Description</FormLabel>
              <Input
                type="text"
                name="description"
                onChange={(e) => {
                  handleChange(e)
                }}
              />

              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                name="startDate"
                onChange={(e) => {
                  handleChange(e)
                }}
              />

              <FormLabel>Start Time</FormLabel>
              <Input
                type="time"
                name="startTime"
                onChange={(e) => {
                  handleChange(e)
                }}
              />

              <FormLabel>End Date</FormLabel>
              <Input
                type="date"
                name="endDate"
                onChange={(e) => {
                  handleChange(e)
                }}
              />

              <FormLabel>End Time</FormLabel>
              <Input
                type="time"
                name="endTime"
                onChange={(e) => {
                  handleChange(e)
                }}
              />
              {
                click ? 
                  <Button
                    mt={4}
                    colorScheme="teal"
                    type="submit"
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                :
                  <Button
                    mt={4}
                    colorScheme="teal"
                    type="submit"
                    onClick={handleSubmit}
                    disabled
                  >
                    Submit
                  </Button>
              }
            </FormControl>
          </ModalBody>
          <ModalFooter style={{ padding: "2rem" }}>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AddEvent